import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CategoryView, categoryHead, loadCategory } from '@/components/deals/CategoryRoute';
import { ComparisonError } from '@/components/comparison/ComparisonError';

const schema = z.object({
  q: z.string().max(80).optional(), loja: z.string().max(120).optional(), color: z.string().max(20).optional(), promo: z.coerce.number().int().min(0).max(1).optional(), sort: z.enum(['discount', 'price', 'recent']).optional(), marca: z.string().max(60).optional(), voltagem: z.string().max(20).optional(), capacidade: z.string().max(20).optional(), tam: z.string().max(12).optional(),
  page: z.coerce.number().int().min(0).max(100).optional(), min: z.coerce.number().min(0).optional(), max: z.coerce.number().min(0).optional(),
});

export const Route = createFileRoute('/ofertas/$categoria/$sub/$publico')({
  validateSearch: schema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) => loadCategory(context.queryClient, { ...deps, categorySlug: params.categoria, subSlug: params.sub, audience: params.publico }),
  head: ({ loaderData, params, match }) => categoryHead(loaderData, `/ofertas/${params.categoria}/${params.sub}/${params.publico}`, (match.search as { page?: number }).page, ['marca', 'voltagem', 'capacidade', 'tam'].some(k => (match.search as Record<string, unknown>)[k])),
  component: function SubcategoriaPublico() {
    const { categoria, sub, publico } = Route.useParams();
    return <CategoryView categorySlug={categoria} subSlug={sub} audience={publico} search={Route.useSearch()} />;
  },
  errorComponent: ({ reset }) => <ComparisonError reset={reset} />,
});
